export default {
    path: "/own",
    name: "own",
    meta: {
        title: "个人设置",
        isDropdown: true,
        icon: "bri-user",
        custom: true
    },
    redirect: {
        name: "baseInfo"
    },
    component: () => import("@/views/own/own.vue"),
    children: [
        {
            path: "base",
            name: "baseInfo",
            meta: {
                title: "个人资料",
                icon: "bri-person"
            },
            props: true,
            component: () => import("@/views/own/baseInfo.vue")
        },
        {
            path: "company",
            name: "companyInfo",
            meta: {
                title: "我加入的团队",
                icon: "bri-company-join"
            },
            props: true,
            component: () => import("@/views/own/companyInfo.vue")
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router/modules/own.js